export function isDateAfterType(value) {
    return Boolean(value && typeof value === "object" && "after" in value);
}
export function isDateBeforeType(value) {
    return Boolean(value && typeof value === "object" && "before" in value);
}
export function isDateRange(value) {
    return Boolean(value && typeof value === "object" && "from" in value);
}
//# sourceMappingURL=Date.typeutils.js.map